import { useEffect, useState } from "react";
import { Button, Card, Col } from "react-bootstrap";
import auxService from "../../services/AuxService";
import { JCard, JCardBody, JTable, JTBody, JTHead } from "../../components/Components";
import { formatDate, formatMoeda } from "../../utils/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faRefresh, faUndo } from "@fortawesome/free-solid-svg-icons";
import { useModalMessage } from "../../components/ModalMessage/useModalMessage";
import { useQuestion } from "../../components/ModalQuestion/useModalQuestion";
import { useModalProcessing } from "../../components/ModalProcessing/useModalProcessing";

interface Pagamentos {
    id: string;
    valor: number;
    data_pagamento: string;
    data_solicitacao: string;
    documento: string;
    e2eId: string;
    comprador_cpfcnpj: string;
    comprador_nome: string;
    status_devolucao: string;
    data_devolucao: string;
    devolucao: number
}

export const IndexDevolucao = () => {
    const [list, setList] = useState<Pagamentos[]>([]);
    const { alertModal, ModalMessageEl } = useModalMessage();
    const { confirm, ConfirmModal } = useQuestion();
    const { startProcessing, stopProcessing, ProcessingModalEl } = useModalProcessing();

    useEffect(() => {
        auxService.getDevolucoes().then(res => {
            setList(res);
        }).catch(error => {
            console.log(error);
        });

    }, []);

    const handleDevolver = async (e2eId: string) => {
        const confirmed = await confirm({
            message: <>Confirma a devolução do pagamento ?</>,
            title: "Confirmação",
            btnConfirmOptions: {
                icon: faCheck,
                title: "Sim, Devolver",
                variant: 'success'
            }
        });
        
        if (confirmed) {
            auxService.devolver(e2eId).then(res => {
                setList((prev) => prev.map((item) =>
                    item.e2eId === e2eId ? {
                        ...item,
                        status_devolucao: res.status_devolucao,
                        data_devolucao: res.data_devolucao,
                    } : item)
                );

            }).catch(err => {
                alertModal(err.response.data.message, 'danger');
            });
        }
    }

    const handleVeriricarDevolver = async (e2eId: string) => {

        const confirmed = await confirm({
            message: <>Confirma a consulta do status da devolução ?</>,
            title: "Confirmação",
            btnConfirmOptions: {
                icon: faCheck,
                title: "Sim, Consultar",
                variant: 'success'
            }
        });
        
        if (confirmed) {
            startProcessing();
            auxService.consultarStatusDevolucao(e2eId).then(res => {
                setList((prev) => prev.map((item) =>
                    item.e2eId === e2eId ? {
                        ...item,
                        status_devolucao: res.status_devolucao
                    } : item)
                );
                stopProcessing();

            }).catch(err => {
                stopProcessing();
            });
        }
      
    }

    return (<div className="row d-flex justify-content-between align-items-start g-2">

        <Col md>
            <JCard>
                <Card.Header className="text-center fw-bold">
                    Lista de devolução
                </Card.Header>
                <JCardBody>
                    <JTable>
                        <JTHead>
                            <tr>
                                <th style={{ width: '11rem' }}>Dt. Pagto</th>
                                <th style={{ width: '11rem' }}>Dt. Solicitação</th>
                                <th style={{ width: '11rem' }}>Dt. Devolução</th>
                                <th>Comprador Nome</th>
                                <th style={{ width: '11rem' }}>Compra CPF/CNPJ</th>
                                <th className="text-center">Valor</th>
                                <th style={{ width: '7rem' }} className="text-center">Ações</th>
                            </tr>

                        </JTHead>
                        <JTBody>
                            {list && (
                                <>
                                    {list?.map((item: Pagamentos) => (
                                        <tr key={item.id}>
                                            <td>{formatDate(item.data_pagamento, 'dd/MM/yyyy H:mm:ss')}</td>
                                            <td>{formatDate(item.data_solicitacao, 'dd/MM/yyyy H:mm:ss')}</td>
                                            <td>{formatDate(item.data_devolucao, 'dd/MM/yyyy H:mm:ss')}</td>
                                            <td>{item.comprador_nome}</td>
                                            <td>{item.comprador_cpfcnpj}</td>
                                            <td className="text-center">{formatMoeda(item.valor)}</td>
                                            <td className="text-center">
                                                {(item.status_devolucao === null || item.status_devolucao === "") ? (

                                                    item.devolucao === 0 ?
                                                        <Button type="button" size="sm" variant="danger" onClick={() => handleDevolver(item.e2eId)}>
                                                            <FontAwesomeIcon icon={faUndo} /> Devolver
                                                        </Button>
                                                        : (<span>SEM DEV.</span>)
                                                ) : (
                                                    <>
                                                        {item.status_devolucao === "EM_PROCESSAMENTO" ? (
                                                            <Button type="button" size="sm" variant="success" onClick={() => handleVeriricarDevolver(item.e2eId)}>
                                                                <FontAwesomeIcon icon={faRefresh} /> VERIFICAR
                                                            </Button>
                                                        ) : (
                                                            <span>{item.status_devolucao}</span>
                                                        )}
                                                    </>
                                                )}
                                            </td>
                                        </tr>
                                    ))}

                                </>
                            )}
                        </JTBody>
                    </JTable>

                </JCardBody>
            </JCard>
        </Col>
        {ModalMessageEl}
        {ConfirmModal}
        {ProcessingModalEl}
    </div>);
}